export default __webpack_public_path__ + "static/media/pexels-artem-podrez-5726850.5238d5ee.jpg";